import React, { useEffect, useState } from "react";

import { useHistory, useParams } from "react-router-dom";

import { Flex, Button, SimpleGrid, Box } from "@chakra-ui/react";

import LoadingSpinner from "../../../components/LoadingSpinner";
import Group from "../Visualizar/Group";
import Informacao from "./Informacao";

import RedeReferenciaSAService from "../../../../main/services/RedeReferenciaSAService";

import SemRegistros from "../../../components/SemRegistros";
import {
  criancaFunc,
  Permission,
  servicoAcolhimentoFunc,
} from "../../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import { useAppContext } from "../../../../Context/MessageContextProvider";

const RedeReferenciaServicoAcolhimento = () => {
  const { id } = useParams();
  const history = useHistory();
  const { roleKeycloack, user } = useAuthProvider();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const { idPJ } = useAppContext();

  useEffect(() => {
    RedeReferenciaSAService.getRedeReferenciaSA(id)
      .then((res) => {
        setLoading(false);
        setData(res.data);
      })
      .catch((erro) => {
        if (erro.response) {
          if (erro.response.data.status === 404) {
            history.push(
              `/servico-acolhimento/cadastrar-rede-de-referencia/${id}`
            );
          }
        }
      });
  }, [history, id]);

  return !loading && data ? (
    <>
      {roleKeycloack &&
      (roleKeycloack.includes(servicoAcolhimentoFunc.visualizarRede) ||
        ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
          roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
          user?.orgaoExterno?.includes(idPJ))) ? (
        <>
          <Group title="Rede de Referência do Serviço" mt="20px">
            <Informacao
              title="TIPO DE REDE DE REFERÊNCIA"
              info="ÓRGÃO"
              bgColor="#ECEFF1"
              mt="20px"
              isHead={true}
            />
            <Informacao
              title="Conselho Tutelar"
              info={data.conselhoTutelar.nome}
              bgColor="#FFFFFF"
            />
            <Informacao title="CREAS" info={data.crea.nome} bgColor="#F9FAFB" />
            <Informacao title="CRAS" info={data.cras.nome} bgColor="#FFFFFF" />
            <Informacao title="UBS" info={data.ubs} bgColor="#F9FAFB" />
            <Informacao
              title="CAPS"
              info={data.cpas ? data.cpas : "Não se aplica"}
              bgColor="#FFFFFF"
            />
            <Informacao
              title="CAPSi"
              info={data.capsi ? data.capsi : "Não se aplica"}
              bgColor="#F9FAFB"
            />
            <Informacao
              title="CAPSad"
              info={data.capsad ? data.capsad : "Não se aplica"}
              bgColor="#FFFFFF"
            />
            <Informacao
              title="Secretaria Municipal de Educação"
              info={
                data.secretariaMunicipal
                  ? data.secretariaMunicipal.nome
                  : "Não se aplica"
              }
              bgColor="#F9FAFB"
            />
            {data.coordenadoria && (
              <Informacao
                title="Coordenadoria Regional de Educação"
                info={data.coordenadoria.nome}
                bgColor="#FFFFFF"
              />
            )}
            <Informacao
              title="Coordenadoria Educacional/Diretoria Regional estadual"
              info={
                data.diretoriaRegional
                  ? data.diretoriaRegional.nome
                  : "Não se aplica"
              }
              bgColor={data.coordenadoria ? "#F9FAFB" : "#FFFFFF"}
            />
          </Group>
          <Group title=" RESPONSÁVEL PELAS INFORMAÇÕES:">
            <Informacao
              title="NOME"
              info="FUNÇÃO/CARGO"
              bgColor="#ECEFF1"
              mt="10px"
              isHead={true}
            />
            <Informacao
              title={data.membroResponsavel.nome}
              info={
                data.membroResponsavel.tipoEquipeAcolhimento.nomeEquipe ===
                "Equipe de Referência"
                  ? data.membroResponsavel.funcaoEquipeAcolhimento.nomeFuncao
                  : data.membroResponsavel.cargoEquipeAcolhimento.nomeCargo
              }
              bgColor="#FFFFFF"
            />
          </Group>

          <SimpleGrid
            mt="30px"
            columns={{ base: 1, sm: 2, lg: 5 }}
            spacing="20px"
            dir="rtl"
          >
            <Permission
              roleKeycloack={roleKeycloack}
              func={servicoAcolhimentoFunc.editarRede}
              id={idPJ}
              user={user}
            >
              <Button
                id="button-editar"
                color="#FFF"
                backgroundColor="#169499"
                fontWeight={700}
                fontSize="15px"
                lineHeight="21.6px"
                _hover={{ bg: "#169499" }}
                onClick={() => {
                  history.push(
                    `/servico-acolhimento/editar-rede-de-referencia/${id}`
                  );
                }}
              >
                Editar
              </Button>
            </Permission>
          </SimpleGrid>
        </>
      ) : (
        <Box mt="2">
          <SemRegistros half buttonVisible={true} />
        </Box>
      )}
    </>
  ) : (
    <Flex w="100%" mt="25%" justifyContent="center">
      <LoadingSpinner />
    </Flex>
  );
};

export default RedeReferenciaServicoAcolhimento;
